import React, { useState, useCallback, useEffect, useRef } from "react";
import { Form, Button, Row, Col, Card } from "@themesberg/react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import moment from "moment";
import { postApi, fetchApi } from "../../../redux/api";
// import { useNavigate } from "react-router-dom";

const TSATransferForm = ({ additionalParams }) => {
  const today = moment().format("YYYY-MM-DD");
  const currentYear = moment().year();
  const [form, setForm] = useState({
    reference_number: "",
    fund_date: today,
    revenue_source_account: "",
    revenue_account_no: "",
    revenue_bank_name: "",
    revenue_sort_code: "",
    expenditure_source_account: "",
    expenditure_account_name: "",
    expenditure_account_no: "",
    expenditure_bank_name: "",
    amount: "",
    physical_year: currentYear, 
    ...additionalParams
  });

  const [revenueAccounts, setRevenueAccounts] = useState([]);
  const [expenditureAccounts, setExpenditureAccounts] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const revenueCodeTypeahead = useRef(null);
  const expenditureTypeahead = useRef(null);
  const [isLoading, setIsLoading] = useState(false);


  const handleFormChange = ({ target: { name, value } }) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const clearForm = () => {
    setForm((prev) => ({
      ...prev,
      revenue_source_account: "",
      revenue_account_no: "",
      revenue_bank_name: "",
      revenue_sort_code: "",
      expenditure_source_account: "",
      expenditure_account_name: "",
      expenditure_account_no: "",
      expenditure_bank_name: "",
      amount: "",
      refereference_number:"",
      physical_year: currentYear,
    }));
    revenueCodeTypeahead.current.clear();
    expenditureTypeahead.current.clear();
    setBanks([]);
    setSelectedBank("");
  };

  // const navigate = useNavigate();
  const handleExpenditureSelection = (selected) => {
    if (selected.length) {
      const selectedItem = selected[0];
      console.log("Expenditure Type Selected:", selectedItem);
      if (
        [
          "Capital Expenditure Account",
          "Recurrent Expenditure Account",
          "Personal Expenditure Account"
        ].includes(selectedItem)
      ) {
        fetchApi(`select_mda_bank_details_by_acc_type`, { type: selectedItem })
          .then((data) => {
            console.log("Fetched Bank Details for Expenditure Type:", data);
            const filteredBanks = data.result.filter(
              (item) => item.account_type === selectedItem
            );
            setBanks(filteredBanks);
          })
          .catch((error) =>
            console.error("Error fetching expenditure banks:", error)
          );
      } else {
        setForm((prev) => ({
          ...prev,
          expenditure_account_name: selectedItem.account_name,
          expenditure_account_no: selectedItem.account_number,
          expenditure_bank_name: selectedItem.bank_name,
          expenditure_source_account: selectedItem.account_info
        }));
      }
    }
  };

  const handleRevenueSelection = (selected) => {
    if (selected.length) {
      const selectedItem = selected[0]; 
      setForm((prev) => ({
        ...prev,
        revenue_source_account: selectedItem.account_name,
        revenue_account_no: selectedItem.account_number,
        revenue_bank_name: selectedItem.bank_name,
        revenue_sort_code: selectedItem.sort_code
      }));
    }
  };

  const fetchAccounts = useCallback(() => {
    fetchApi(`select_mda_bank_details_by_acc_type`)
      .then((data) => {
        console.log("Fetched Accounts:", data); 
        if (data.result) {
          const revenue = data.result.filter(
            (item) => item.account_type === "Revenue Account"
          );
          const expenditure = data.result.filter(
            (item) => item.account_type !== "Revenue Account"
          );
          setRevenueAccounts(revenue);
          setExpenditureAccounts([
            "Capital Expenditure Account",
            "Recurrent Expenditure Account",
            "Personal Expenditure Account"
          ]);
        }
      })
      .catch((error) => console.error("Error fetching accounts:", error));
  }, []);


  const handleSubmit = () => {
    setIsLoading(true);
    console.log("Submitting Form:", form); 
    postApi(`post_tsa_transfer`, { ...form, query_type: "tsa_transfer" })
      .then((response) => {
        console.log("Form Submitted Successfully:", response);
        clearForm();
        alert("Form Submitted Successfully");
        setIsLoading(false);
      })
      .catch((error) => console.error("Error submitting form:", error));
  };

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  return (
    <>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          <h5 className="mb-4">Transfer Form</h5>
          {/* {JSON.stringify(form)}  */}
          <Form>
            <Row className="mb-3">
            <Col md="6">
                <Form.Group controlId="budgetYear">
                  <Form.Label>Fiscal Year</Form.Label>
                  <Form.Control
                    type="text" 
                    name="physical_year"
                    value={form.physical_year}
                    disabled 
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="fundDate">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="fund_date"
                    value={form.fund_date}
                    onChange={handleFormChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md="6">
                <Form.Label>Select Source Account</Form.Label>
                <Typeahead
                  id="revenue-source-account"
                  ref={revenueCodeTypeahead}
                  options={revenueAccounts}
                  labelKey={(option) =>
                    `${option.account_number} - ${option.account_name} - ${option.balance}`
                  }
                  onChange={handleRevenueSelection}
                  placeholder="Select Source account..."
                />
              </Col>
              <Col md="6">
                <Form.Label>Select Expenditure Type</Form.Label>
                <Typeahead
                  id="expenditure-source-account"
                  ref={expenditureTypeahead}
                  options={expenditureAccounts}
                  labelKey={(option) =>
                    typeof option === "string" ? option : option.account_name
                  }
                  onChange={handleExpenditureSelection}
                  placeholder="Select Expenditure type..."
                />
              </Col>
            </Row>

            {banks.length > 0 && (
              <Row className="mb-3">
                <Col md="6">
                  <Typeahead
                    id="expenditure-source-account"
                    ref={expenditureTypeahead}
                    options={banks}
                    labelKey={(i) => `${i.bank_name}-${i.account_name}`}
                    onChange={(data) =>
                      setForm((p) => ({
                        ...p,
                        expenditure_account_no: data[0]?.account_number,
                        expenditure_account_name: data[0]?.account_name,
                        expenditure_bank_name: data[0]?.bank_name,
                      }))
                    }
                    placeholder="Select Expenditure type..."
                  />
                </Col>
              </Row>
            )}

            <Row className="mb-3">
              <Col md="6">
                <Form.Group controlId="amount">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="amount"
                    value={form.amount}
                    onChange={handleFormChange}
                    placeholder="Enter amount"
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button variant="secondary" className="me-2" onClick={clearForm}>
                Reset
              </Button>
              <Button variant="primary" disabled={isLoading} onClick={handleSubmit}>
                {isLoading ? "Please wait..." : "Submit"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};

export default TSATransferForm;
